import React, { useState } from 'react';

import { AutoComplete } from '../../components';
import { Form, FormItem, SubmitButton, Button } from '../../components';

type ValueType = { serverId?: string };
type AssignLiveKitServerFormProps = {
  saving: boolean;
  servers: OptionType[];
  currentServerId?: string | null;

  onCancel: () => void;
  onSave: (serverId: string) => void;
};

export const AssignLiveKitServerForm: React.FC<
  AssignLiveKitServerFormProps
> = ({ saving, servers, currentServerId, onSave, onCancel }) => {
  const [values, setValues] = useState<ValueType>({
    serverId: currentServerId ?? undefined,
  });

  return (
    <div className="flex flex-col gap-y-12 w-full">
      <Form onChange={setValues} initialValue={values}>
        <FormItem<ValueType>
          required
          name="serverId"
          label="LiveKit Server"
          inline={false}
        >
          <AutoComplete options={servers} placeholder="Select LiveKit Server" />
        </FormItem>

        <div className="flex flex-col gap-y-md justify-center items-center">
          <SubmitButton
            size="large"
            label="Save"
            disabled={saving || values.serverId === currentServerId}
            className="w-full"
            onClick={() => onSave(values?.serverId!)}
          />
          <Button
            size="large"
            type="light"
            label="Cancel"
            className="w-full"
            onClick={onCancel}
          />
        </div>
      </Form>
    </div>
  );
};
